<template>
  <div id="app">
    <v-app id="inspire">
      <v-container grid-list-xl fluid>
        <!-- mini statistic start -->
        <v-tabs color="white" slider-color="primary" height="200%" grow>
          <v-layout row wrap>
            <v-tab @click.native="step = 1">
              <!-- <v-flex xl12 lg12 md12 sm12 xs12>
                <linearStatistic
                  :title="'Basket Available in Store'"
                  :sub-title=" cleanbasket +'   +   '+extrabasket +'   /'+totalbasket + ' Units'  "
                  :icon="'list'"
                  :color="'primary'"
                  :value="''"
                ></linearStatistic>
              </v-flex>-->

              <v-flex xl12 lg12 md12 sm12 xs12>
                <v-card color="white">
                  <v-card-title class="pb-0">
                    <div class="subheading">Total Basket :</div>
                    <h2>{{totalBasket}}</h2>
                  </v-card-title>
                  <v-card-title class="pb-0">
                    <div class="subheading">Customer & Farmer owe us :</div>
                    <h2>{{totalOweUs}}</h2>
                  </v-card-title>
                  <v-card-title>
                    <div class="subheading">We owe others :</div>
                    <h2>{{totalWeOwe}}</h2>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-tab>

            <v-tab @click.native="step = 2">
              <v-flex xl12 lg12 md12 sm12 xs12>
                <linearStatistic
                  :title="'Total Farmers Basket'"
                  :sub-title="''"
                  :icon="'store'"
                  :color="'primary'"
                  :value="''"
                ></linearStatistic>
              </v-flex>
            </v-tab>

            <v-tab @click.native="step = 3">
              <v-flex xl12 lg12 md12 sm12 xs12>
                <linearStatistic
                  :title="'Total Customers Basket'"
                  :sub-title="''"
                  :icon="'store'"
                  :color="'primary'"
                  :value="''"
                ></linearStatistic>
              </v-flex>
            </v-tab>
            <v-tab @click.native="step = 4">
              <v-flex xl12 lg12 md12 sm12 xs12>
                <linearStatistic
                  :title="'Total Drivers Basket'"
                  :sub-title="''"
                  :icon="'fa fa-user-secret'"
                  :color="'primary'"
                  :value="''"
                ></linearStatistic>
              </v-flex>
            </v-tab>
          </v-layout>
          <v-spacer></v-spacer>
        </v-tabs>

        <v-layout row wrap>
          <v-flex sm12>
            <v-stepper v-model="step">
              <v-stepper-items>
                <v-stepper-content step="1">
                  <VWidget title="Action">
                    <div slot="widget-content">
                      <v-layout row wrap>
                        <v-toolbar flat color="white">
                          <v-toolbar-title>
                            <span style="color:#0cabc2">Manage BASKET in FACTORY</span>
                          </v-toolbar-title>
                        </v-toolbar>
                        <v-flex xs3>
                          <v-dialog v-model="dialog_add_basket" persistent max-width="500px">
                            <v-btn color="primary" dark slot="activator">Add basket to Factory(new)</v-btn>
                            <v-card>
                              <v-card-title>
                                <span class="headline">Adding basket</span>
                              </v-card-title>
                              <v-divider></v-divider>
                              <v-card-text>
                                <v-container grid-list-md>
                                  <v-layout wrap>
                                    <v-flex xs12 lg12 sm12 md12>
                                      <v-text-field
                                        label="Basket Quantity"
                                        v-model="addbasketqty"
                                        type="number"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 lg12 sm12 md12>
                                      <v-text-field v-model="add_reason" label="Reason"></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  flat
                                  @click.native="dialog_add_basket= false"
                                >Close</v-btn>
                                <v-btn color="blue darken-1" flat @click.native="addBasket">Save</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                        <v-flex xs3>
                          <v-dialog v-model="dialog_remove_basket" persistent max-width="500px">
                            <v-btn
                              color="primary"
                              dark
                              slot="activator"
                            >Remove Factory Basket (Missing or Broken)</v-btn>
                            <v-card>
                              <v-card-title>
                                <span class="headline">Missing & Broken</span>
                              </v-card-title>
                              <v-divider></v-divider>
                              <v-card-text>
                                <v-container grid-list-md>
                                  <v-layout wrap>
                                    <v-flex xs12 lg12 sm12 md12>
                                      <v-text-field
                                        label="Quantity"
                                        v-model="removebasketqty"
                                        type="number"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 lg12 sm12 md12>
                                      <v-text-field v-model="remove_reason" label="Reason"></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  flat
                                  @click.native="dialog_remove_basket = false"
                                >Close</v-btn>
                                <v-btn color="blue darken-1" flat @click.native="removeBasket">Save</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                      <v-divider></v-divider>

                      <v-layout row wrap>
                        <v-toolbar flat color="white">
                          <v-toolbar-title>
                            <span style="color:#0cabc2">Manage BASKET For FARMER and CUSTOMER</span>
                          </v-toolbar-title>
                        </v-toolbar>
                        <v-flex xs2>
                          <v-select v-model="user" :items="users" label="Adjust Basket for" solo></v-select>
                        </v-flex>
                        <v-flex xs10>
                          <v-card class="mx-auto" outlined>
                            <v-container grid-list-xl fluid>
                              <v-layout xs12 row wrap>
                                <v-flex xs2>
                                  <v-menu
                                    lazy
                                    :close-on-content-click="true"
                                    v-model="date_box"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :nudge-right="40"
                                    max-width="290px"
                                    min-width="290px"
                                  >
                                    <v-text-field
                                      v-if="user=='Farmer' || user=='Customer'"
                                      slot="activator"
                                      label="Date"
                                      v-model="date"
                                      persistent-hint
                                      outline
                                      readonly
                                    ></v-text-field>

                                    <v-date-picker
                                      v-model="date"
                                      @input="date_box = false"
                                      no-title
                                      actions
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs2>
                                  <v-autocomplete
                                    v-model="customer_or_farmer"
                                    :items="customerList"
                                    item-text="name"
                                    item-value="id"
                                    label="Customer"
                                    ref="customer"
                                    persistent-hint
                                    return-object
                                    small-
                                    outline
                                    v-if="user=='Customer'"
                                  ></v-autocomplete>
                                  <v-autocomplete
                                    v-model="customer_or_farmer"
                                    :items="farmerList"
                                    item-text="name"
                                    item-value="id"
                                    label="Farmer"
                                    ref="farmer"
                                    persistent-hint
                                    return-object
                                    outline
                                    v-if="user=='Farmer'"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex xs3>
                                  <v-select
                                    v-if="user=='Farmer'"
                                    v-model="action"
                                    :items="farmer_selection"
                                    item-text="text"
                                    item-value="value"
                                    label="Action"
                                    outline
                                  ></v-select>
                                  <v-select
                                    v-if="user=='Customer'"
                                    v-model="action"
                                    :items="customer_selection"
                                    item-text="text"
                                    item-value="value"
                                    label="Action"
                                    outline
                                  ></v-select>
                                </v-flex>
                                <v-flex xs2>
                                  <v-text-field
                                    v-if="user=='Farmer' || user=='Customer'"
                                    v-model="basket_quantity"
                                    v-on:change="basket_quantity = Math.max(Math.min(Math.round(basket_quantity), 9999999), 1)"
                                    type="number"
                                    label="Qty (no need type -)"
                                    outline
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs2>
                                  <v-text-field
                                    v-if="user=='Farmer' || user=='Customer'"
                                    v-model="basket_reason"
                                    label="Reason/Remark(may ingore)"
                                    outline
                                  ></v-text-field>
                                </v-flex>

                                <v-flex xs1>
                                  <v-btn
                                    class="mx-2"
                                    v-if="user=='Farmer' || user=='Customer'"
                                    small
                                    fab
                                    dark
                                    color="indigo"
                                    @click="manageBasket()"
                                  >
                                    <v-icon dark>add</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <!-- <v-layout row wrap>
                        <v-toolbar flat color="white">
                          <v-toolbar-title>
                            <span style="color:#0cabc2">Manage BASKET For FARMER and CUSTOMER</span>
                          </v-toolbar-title>
                        </v-toolbar>
                        <v-flex xs12>
                        <v-card>
                          <v-toolbar flat color="primary" dark>
                            <v-toolbar-title></v-toolbar-title>
                          </v-toolbar>
                          <v-tabs vertical>
                            <v-tab>
                              <v-icon left>mdi-account</v-icon>Manual
                            </v-tab>
                            <v-tab>
                              <v-icon left>mdi-lock</v-icon>PO
                            </v-tab>
                            <v-tab>
                              <v-icon left>mdi-access-point</v-icon>DO
                            </v-tab>

                            <v-tab-item>
                              <v-card flat>
                                <v-card-text>aaaa</v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item>
                              <v-card flat>
                                <v-card-text>bbbb</v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item>
                              <v-card flat>
                                <v-card-text>cccc</v-card-text>
                              </v-card>
                            </v-tab-item>
                          </v-tabs>
                        </v-card>
                        </v-flex>
                      </v-layout> -->

                      <v-divider></v-divider>

                      <v-layout row wrap>
                        <v-toolbar flat color="white">
                          <v-toolbar-title>
                            <span style="color:#0cabc2">Record</span>
                          </v-toolbar-title>
                        </v-toolbar>
                        <v-flex xs12>
                          <ManualBasketRecord ref="ManualBasketRecord"></ManualBasketRecord>
                        </v-flex>
                      </v-layout>
                    </div>
                  </VWidget>

                  <!-- <admin_table ref="admin_ref"></admin_table> -->
                </v-stepper-content>

                <v-stepper-content step="2">
                  <VWidget title="Farmer Basket">
                    <div slot="widget-content"></div>
                  </VWidget>

                  <farmer_table ref="farmer_table"></farmer_table>
                </v-stepper-content>
                <v-stepper-content step="3">
                  <VWidget title="Customer Basket">
                    <div slot="widget-content"></div>
                  </VWidget>

                  <customer_table ref="customer_table"></customer_table>
                </v-stepper-content>

                <v-stepper-content step="4">
                  <VWidget title="Driver Basket">
                    <div slot="widget-content"></div>
                  </VWidget>

                  <!-- <driver_table></driver_table> -->
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-container>

      <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
        No Internet Connection
        <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>

      <v-snackbar v-model="snackbar_message" :bottom="true" :multi-line="true" :timeout="4000">
        {{message}}
        <v-btn color="primary" flat @click="snackbar_message = false">Close</v-btn>
      </v-snackbar>
    </v-app>
  </div>
</template>
    <script>
import linearStatistic from "@/components/widget/linear_statistic";
import VWidget from "@/components/widget/vwidget";
import moment from "moment";

import ManualBasketRecord from "@/components/datatables/ManualBasketRecord";
// import driver_table from "@/components/basket/driverDataTable";
import farmer_table from "@/components/datatables/farmer_basket_table";
import customer_table from "@/components/datatables/customer_basket_table";

import axios from "axios";
import baseUrl from "@/api/baseurl";

export default {
  components: {
    VWidget,
    linearStatistic,
    ManualBasketRecord,
    // driver_table,
    farmer_table,
    customer_table
    // basket_Farmer_assign_return,
    // basket_Customer_assign_return
  },
  data() {
    return {
      baseUrl: baseUrl,
      snackbar: false,
      snackbar_message: false,
      message: "",

      step: 1,

      totalBasket: "",
      totalOweUs: "",
      totalWeOwe: "",

      addbasketqty: "",
      removebasketqty: "",
      add_reason: "",
      remove_reason: "",
      date: moment().format("YYYY-MM-DD"),

      customerList: [],
      farmerList: [],
      //   customer: "",
      //   farmer: "",
      customer_or_farmer: "",

      user: "",
      users: ["Farmer", "Customer"],
      farmer_selection: [
        {text: "Factory Give Basket to Farmer 菜园欠我们罗",value:"1"},
        {text: "Farmer give/return basket to Factory我们欠菜园罗" ,value:"2"},
       
      ],
      // customer_selection: ["Customer return basket to Factory"],
      customer_selection: [
         {text: "Customer return basket to Factory 我们欠商家罗",value:"3"},
        {text: "Factory give basket to Customer 商家欠我们罗" ,value:"4"}
        ],

      basket_quantity: "",
      basket_reason: "",

      dialog_add_basket: false,
      dialog_remove_basket: false
    };
  },

  created() {
    // this.getManualBasketRecord();
    this.getCustomer();
    this.getFarmer();
    this.getBasketDetail();
  },

  methods: {
    getCustomer() {
      const params = new URLSearchParams();
      params.append("get_customer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_customer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.customerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Customer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getFarmer() {
      const params = new URLSearchParams();
      params.append("get_farmer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_farmer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.farmerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Farmer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getBasketDetail() {
      const params = new URLSearchParams();
      params.append("getBasketDetail", "getBasketDetail");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/basket_manage/basket_manage.php",
        data: params
      })
        .then(response => {
          this.totalBasket = response.data.total;
          this.totalOweUs = response.data.totalOweUs;
          this.totalWeOwe = response.data.totalWeOwn;
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    addBasket() {
      if (this.addbasketqty != "" && this.addbasketqty != "0") {
        const params = new URLSearchParams();
        params.append("add_basket", "add_basket");
        params.append("quantity", this.addbasketqty);
        params.append("reason", this.add_reason);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/basket_manage/basket_manage.php",
          data: params
        })
          .then(response => {
            this.dialog_add_basket = false;
            this.addbasketqty = "";
            this.add_reason = "";
            this.getBasketDetail();
            this.$refs.ManualBasketRecord.record();

            this.snackbar_message = true;
            this.message = response.data.message;
          })
          .catch(error => {
            console.log(error);
            this.snackbar = true;
          });
      } else {
        this.snackbar_message = true;
        this.message = "Please do not leave blank or 0";
      }
    },
    removeBasket() {
      if (this.removebasketqty != "" && this.removebasketqty != "0") {
        const params = new URLSearchParams();
        params.append("remove_basket", "adminBasketControl");
        params.append("quantity", this.removebasketqty);
        params.append("reason", this.remove_reason);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/basket_manage/basket_manage.php",
          data: params
        })
          .then(response => {
            this.dialog_remove_basket = false;
            this.removebasketqty = "";
            this.remove_reason = "";
            this.getBasketDetail();
            this.$refs.ManualBasketRecord.record();

            this.snackbar_message = true;
            this.message = response.data.message;
          })
          .catch(error => {
            console.log(error);
            this.snackbar = true;
          });
      } else {
        this.snackbar_message = true;
        this.message = "Please do not leave blank or 0";
      }
    },
    manageBasket() {
      if (
        this.customer_or_farmer != "" &&
        this.action != "0" &&
        this.basket_quantity != ""
      ) {

        const params = new URLSearchParams();
        if (this.action == "3") {
          params.append(
            "customer_return_basket_to_admin",
            "customer_return_basket_to_admin"
          );
          params.append("date", this.date);
          params.append("customer_id", this.customer_or_farmer.id);
          params.append("quantity", this.basket_quantity);
          params.append("reason", this.basket_reason);
        }else if (this.action == "4") {
          params.append(
            "admin_give_basket_to_Customer",
            "admin_give_basket_to_Customer"
          );
          params.append("date", this.date);
          params.append("customer_id", this.customer_or_farmer.id);
          params.append("quantity", this.basket_quantity);
          params.append("reason", this.basket_reason);
        } else if (this.action == "1") {
          params.append(
            "admin_give_basket_to_Farmer",
            "admin_give_basket_to_Farmer"
          );
          params.append("date", this.date);
          params.append("farmer_id", this.customer_or_farmer.id);
          params.append("quantity", this.basket_quantity);
          params.append("reason", this.basket_reason);
        } else if (this.action == "2") {
          params.append(
            "farmer_return_basket_to_admin",
            "farmer_return_basket_to_admin"
          );
          params.append("date", this.date);
          params.append("farmer_id", this.customer_or_farmer.id);
          params.append("quantity", this.basket_quantity);
          params.append("reason", this.basket_reason);
        }

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/basket_manage/basket_manage.php",
          data: params
        })
          .then(response => {
            this.$refs.ManualBasketRecord.record();

            this.basket_quantity = "";
            this.basket_reason = "";
            this.customer_or_farmer = "";
            this.action = "";
            this.getBasketDetail();
            this.$refs.farmer_table.record();
            this.$refs.customer_table.record();

            this.snackbar_message = true;
            this.message = response.data.message;
          })
          .catch(error => {
            console.log(error);
            this.snackbar = true;
          });
      } else {
        this.snackbar_message = true;
        this.message = "Please fill all the detail";
      }
    }
  }
};
</script>
    
  
  